<template>
  <div class="container">
    <nav>
      <a href="/"><img src="/static/images/logo.svg" alt="1000 könyv"></a>
      <div class="search">
        <button v-bind:class="{'d-none': searchVisible}" class="btn btn-clear btn-icon" v-on:click="searchClick"><img src="/static/images/icons/search.svg"></button>
        <button v-bind:class="{'d-none': !searchVisible}" class="btn btn-clear btn-icon"><img src="/static/images/icons/cart-delete.svg"></button>
        <form v-bind:class="{ searchVisible: searchVisible}" method="POST" v-on:submit.prevent="search"><input type="search" class="form-control searchInput" ref="searchInput" placeholder="Keresés..." v-on:blur="searchInputBlur" v-model="searchInput"></form>
      </div>
      <div class="navBtns">
        <a href="/kosar" class="btn btn-clear btn-icon btnCart"><img src="/static/images/icons/cart.svg"><span v-if="cartNum > 0">{{cartNum}}</span></a>
        <button class="btn btn-clear btn-icon btnMenu" v-on:click="menuToggle"><img src="/static/images/icons/menu.svg"></button>
        <div class="menu">
          <div class="container">
            <button class="btn btn-link closeBtn" v-on:click="menuToggle"><img src="/static/images/icons/cart-delete.svg" alt=""></button>
          </div>
          <ul>
            <li><a href="/">Főoldal</a></li>
            <li><a href="/konyvek">Könyvek</a></li>
            <li><a href="https://shop.konyvmogul.hu" target="_blank">Webáruház</a></li>
            <li><a href="https://konyvmogul.hu/bemutatkozas/" target="_blank">Bemutatkozunk</a></li>
            <li><a href="https://1000konyv.blog.hu" target="_blank">Blog</a></li>
            <li><a href="https://shop.konyvmogul.hu/index.php?route=information/contact" target="_blank">Kapcsolat</a></li>
            <li><a href="/kosar">Kosár</a></li>
            <li><a href="/docs/aszf.pdf" target="_blank">ÁSZF</a></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'FrontendNav',
  data: function () {
    return {
      cartItems: [],
      searchVisible: false,
      searchInput: null
    }
  },
  mounted: function () {
    if (localStorage.getItem('cartItems')) {
      try {
        this.cartItems = JSON.parse(localStorage.getItem('cartItems'))
        this.$store.commit('loading/setCartNum', this.cartItems.length)
      } catch (e) {
        localStorage.removeItem('cartItems')
      }
    }
  },
  methods: {
    search: function () {
      this.$router.push('/kereses/' + this.searchInput)
    },
    searchClick: function () {
      console.log('searchClick')
      if (!this.searchVisible) {
        this.searchVisible = true
        this.$refs.searchInput.focus()
      }
    },
    searchInputBlur: function () {
      this.searchVisible = false
      this.$refs.searchInput.blur()
    },
    menuToggle: function () {
      window.$('body').toggleClass('menuOpen')
    }
  },
  computed: {
    cartNum: function () {
      // set:
      // this.$store.commit('loading/setCartNum', 4)
      // get:
      return this.$store.state.loading.cartNum
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/nav.vue